import { render } from "./app.vue?vue&type=template&id=0d9c003c"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"cartridges/app_project_travels/cartridge/client/default/js/plp_lp/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d9c003c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d9c003c', __exports__)) {
    api.reload('0d9c003c', __exports__)
  }
  
  module.hot.accept("./app.vue?vue&type=template&id=0d9c003c", () => {
    api.rerender('0d9c003c', render)
  })

}


export default __exports__